import React from 'react';
import FinalCTA from './FinalCTA';

const TransformCTA: React.FC = () => {
  return (
    <section className="bg-[#4d5ae4] py-12 lg:py-16 relative overflow-hidden">
      {/* Darker accent on left half — hidden on mobile */}
      <div className="absolute top-0 left-0 w-1/2 h-full bg-[#4653d5] hidden lg:block" />

      <div className="max-w-content mx-auto px-6 relative z-10">
        {/* Decorative vertical divider — hidden on mobile */}
        <img
          className="absolute left-[55px] top-0 w-px h-full object-cover opacity-30 hidden lg:block pointer-events-none"
          src={require('../assets/img/footer/vertical-divider.svg').default}
          alt=""
        />

        {/* Decorative horizontal lines — hidden on mobile */}
        <div className="absolute left-0 top-0 w-1/2 h-full hidden lg:block pointer-events-none">
          <img className="absolute left-0 w-full h-px object-cover opacity-30" style={{ top: '10%' }} src={require('../assets/img/footer/horizontal-line.svg').default} alt="" />
          <img className="absolute left-0 w-full h-px object-cover opacity-30" style={{ top: '17%' }} src={require('../assets/img/footer/horizontal-line.svg').default} alt="" />
          <img className="absolute left-0 w-full h-px object-cover opacity-30" style={{ top: '21%' }} src={require('../assets/img/footer/horizontal-line.svg').default} alt="" />
          <img className="absolute left-0 w-full h-px object-cover opacity-30" style={{ top: '28%' }} src={require('../assets/img/footer/horizontal-line.svg').default} alt="" />
          <img className="absolute left-0 w-full h-px object-cover opacity-30" style={{ top: '37%' }} src={require('../assets/img/footer/horizontal-line.svg').default} alt="" />
          <img className="absolute left-0 w-full h-px object-cover opacity-30" style={{ top: '60%' }} src={require('../assets/img/footer/horizontal-line-alt.svg').default} alt="" />
          <img className="absolute left-0 w-full h-px object-cover opacity-30" style={{ top: '69%' }} src={require('../assets/img/footer/horizontal-line.svg').default} alt="" />
          <img className="absolute left-0 w-full h-px object-cover opacity-30" style={{ top: '96%' }} src={require('../assets/img/footer/horizontal-line.svg').default} alt="" />
        </div>

        <div className="flex flex-col lg:flex-row items-start gap-8 lg:gap-16">
          {/* Left: Transform heading image */}
          <div className="flex-1 w-full">
            <img
              className="w-full max-w-[300px] lg:max-w-[549px] h-auto mx-auto lg:mx-0"
              src={require('../assets/img/transform-cta/ready-to-transform.png')}
              alt="Ready To Transform your IDEAS?"
            />
          </div>

          {/* Right: FinalCTA */}
          <div className="flex-1 lg:pt-4">
            <FinalCTA />
          </div>
        </div>
      </div>
    </section>
  );
};

export default TransformCTA;
